import React from 'react';
import { injectIntl } from 'react-intl';

const FieldErrorMessage = (props) => {
	let classes = ['gui_error_field', 'redIcon', 'mod_align_left'];
	if(props.error_msg_position_class != undefined) {
		classes.push(props.error_msg_position_class);
	}

	let error_msg = props?.children ?? "This field has errors";
	let error_msg_html = false;
	if(typeof error_msg == 'string' && error_msg != ' ') {
		error_msg = props.intl.formatMessage({ id:error_msg });
	} else if(typeof error_msg == 'object') {
		error_msg_html = true;
	} else {
		classes.push('only_icon');
	}

	const classname = classes.join(' ');

	if(error_msg_html) {
		return (
			<div class={classname}>{error_msg}</div>
		)
	}

	return (
		<div
			class={classname}
			dangerouslySetInnerHTML={{ __html:error_msg }}
		/>
	);
}

export default injectIntl(FieldErrorMessage);